import theme from 'src/theme';
import styled from 'styled-components';

export const LoginWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    position: absolute;
    top: 200px;
    left: 200px;
    background: #fff;
    border-radius: 4px;
    padding: 10px 40px 40px 40px;

    @media (max-width: 768px) {
        position: static;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        padding: 2rem 1.5rem;
        min-height: 100vh;
        width: 100%;
        box-sizing: border-box;
    }
`;

export const LoginContent = styled.div`
    text-align: center;
    width: 200px;
    h1 {
        font-weight: 200;
    }
    p {
        font-size: 17px;
        line-height: 1.5;
    }
    button {
        margin: 20px 0 0;
        background: ${theme.legacyColors.darkBlue};
        padding: 10px 30px;
        border-radius: 4px;
        border: 0;
        color: #fff;
        font-size: 15px;
        outline: none;
        cursor: pointer;
    }
`;

export const ErrorMessage = styled.div`
    background: #fee2e2;
    border: 1px solid #ef4444;
    color: #b91c1c;
    padding: 16px 20px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.4;
    max-width: 300px;
    display: flex;
    flex-direction: column;
`;

export const LoadingOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.85);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

export const Spinner = styled.div`
    width: 48px;
    height: 48px;
    border: 4px solid ${theme.legacyColors.darkBlue};
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;

export const LoadingText = styled.p`
    margin-top: 16px;
    font-size: 16px;
    color: ${theme.legacyColors.darkBlue};
`;

export const AccountInfo = styled.div`
    font-weight: 600;
    margin: 8px 0;
    padding: 8px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    word-break: break-word;
`;

export const SignOutButton = styled.button`
    margin-top: 12px;
    padding: 8px 16px;
    background: transparent;
    border: 1px solid #b91c1c;
    color: #b91c1c;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #b91c1c;
        color: white;
    }
`;

export const ClearCacheLink = styled.a`
    display: block;
    margin-top: 24px;
    font-size: 12px;
    color: #6b7280;
    text-decoration: underline;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
        color: #374151;
    }
`;
